


import './login.js';
  import './scrolltotop.js';
    import './darkbrighttoggle';

  import './alerts.js';
  import './register.js';
  import './cart.js';

console.log('app.js loaded!');






